export default __webpack_public_path__ + "static/media/home_tire_desktop.5fa52c54.jpg";